<div fxLayout="column" class="neq-dialog">
    <div *ngIf="messageHeader" [innerHTML]="messageHeader"></div>

    <div class="rgpd-div" *ngIf="messageCheckboxTerms">
        <input #termsAcceptance type="checkbox" id="termsAcceptance" name="scales">
        <label for="termsAcceptance" [innerHTML]="messageCheckboxTerms"></label>
        <p #termsAcceptanceError id="termsAcceptanceError" *ngIf="messageErrorTerms" [innerHTML]="messageErrorTerms" hidden></p>
    </div>

    <div class="rgpd-div" *ngIf="messageCheckboxPersonalData">
        <input #personalDataAcceptance type="checkbox" id="personalDataAcceptance" name="scales">
        <label for="personalDataAcceptance" [innerHTML]="messageCheckboxPersonalData"></label>
    </div>

    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.cancel' | translate}}" (click)="goBack()"></button>
    </div>
</div>
